import React, { Component } from "react";
// import { useSelector } from "react-redux";
// import { useHistory } from "react-router-dom";
import { Link, Redirect } from "react-router-dom";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import ALink from "@material-ui/core/Link";
import ApartmentOutlinedIcon from "@material-ui/icons/ApartmentOutlined";
import PermIdentityOutlinedIcon from "@material-ui/icons/PermIdentityOutlined";
import Typography from "@material-ui/core/Typography";
import Terms from "./Terms.js";
import { withStyles } from "@material-ui/styles";
import API from "../../actions";
import Copyright from "./Copyright";
import styles from "./styles";
import Joi from "joi-browser";
import Alert from "../Alerts/alert";
import Loading from "../Common/loading";
const useStyles = withStyles(theme => styles);

class Register extends Component {
    state = {
        data: {
            nameFirst: "",
            nameLast: "",
            phone: "",
            // username: '',
            email: "",
            password: "",
            confirmPassword: "",

            companyName: "",
            CVR: "",
            town: "",
            post: "",
            address: "",
            companyEmail: "",
            companyPhone: ""
        },
        errors: {},
        checkboxes: {
            checked: false,
            sendEmails: true,
            terms: false
        },
        errorMessage: "",
        openLoading: false
    };

    schema = {
        nameFirst: Joi.string().required().label("Fornavn"),
        nameLast: Joi.string().required().label("Efternavn"),
        phone: Joi.string()
            .required()
            .regex(/^\+*\d{8,}$/)
            .label("Telefon"),
        email: Joi.string().email().required().label("Email"),
        password: Joi.string().min(6).required().label("Adgangskode"),
        confirmPassword: Joi.string().min(6).required().valid(Joi.ref("password")).label("Bekræft kodeord"),
        companyName: Joi.string().required().label("Klinikens navn / Firmanavn"),
        CVR: Joi.number().integer().allow("").allow(null).label("CVR"),
        town: Joi.string().required().label("By"),
        post: Joi.number().integer().required().label("Postnummer"),
        address: Joi.string().required().label("Adresse"),
        companyEmail: Joi.string().email().required().label("Virksomheds e-mail"),
        companyPhone: Joi.string()
            .required()
            .regex(/^\+*\d{8,}$/)
            .label("Virksomheds telefon")
    };

    validateProperty = ({ name, value }) => {
        const obj = { [name]: value };
        let schema = { [name]: this.schema[name] };

        if (name === "confirmPassword") {
            schema = {
                [name]: Joi.string().min(6).required().valid(this.state.data["password"]).label("Bekræft kodeord")
            };
        }
        const result = Joi.validate(obj, schema);
        console.log(name, value);
        console.log(result);
        if (!result.error) return null;
        return result.error.details[0].message;
    };
    handleChange = ({ currentTarget: input }) => {
        const errors = { ...this.state.errors };
        const errorMessage = this.validateProperty(input);
        if (errorMessage) errors[input.name] = errorMessage;
        else delete errors[input.name];
        const data = { ...this.state.data };
        data[input.name] = input.value;
        this.setState({ data, errors });
    };

    validateForm = () => {
        const options = {
            abortEarly: false
        };

        const result = Joi.validate(this.state.data, this.schema, options);
        if (!result.error) return null;
        const errors = {};
        for (let item of result.error.details) errors[item.path[0]] = item.message;
        return errors;
    };

    handleSubmit = async e => {
        e.preventDefault();

        const errors = this.validateForm();
        this.setState({ errors: errors || {} });
        if (errors) {
            console.log("errors", errors);
            return;
        }
        const { checkboxes, data } = this.state;

        if (!checkboxes.checked)
            return this.setState({ errorMessage: "Du skal bekræfte handelsbetingelser og databehandleraftale" });

        try {
            this.setState({ openLoading: true });
            await API.register(
                {
                    username: data.email,
                    email: data.email,
                    password: data.password,
                    newsletter: checkboxes.sendEmails,
                    nameFirst: data.nameFirst,
                    nameLast: data.nameLast,
                    phone: data.phone,
                    trial: Date.now() + 1000 * 60 * 60 * 24 * 1 * 30
                },
                {
                    companyName: data.companyName,
                    CVR: data.CVR,
                    town: data.town,
                    post: data.post,
                    address: data.address,
                    email: data.companyEmail,
                    phone: data.companyPhone,
                    trial: Date.now() + 1000 * 60 * 60 * 24 * 1 * 30,
                    newsletter: checkboxes.sendEmails,
                    moms: true
                }
            );
            this.setState({ openLoading: false });
            await API.login(data.email, data.password);
            this.props.history.push("/");
        } catch (err) {
            this.setState({ openLoading: false });
            if (err === "username taken") {
                this.setState({ errorMessage: "Brugernavnet er taget" });
            } else {
                this.setState({
                    errorMessage: err ? "Fejl: " + err : "Fejl: Cannot connect to the server. Please try again."
                });
            }
        }
    };

    renderInput = (label, type = "text", name, autoFocus = false, maxlength = 0, required = true) => {
        const { data } = this.state;
        const { errors } = this.state;
        const inputProps = {};
        if (maxlength > 0) {
            inputProps["maxLength"] = maxlength;
        }

        return (
            <TextField
                variant="outlined"
                margin="normal"
                required={required}
                fullWidth
                id={name}
                label={label}
                name={name}
                value={data[name]}
                autoComplete={name}
                autoFocus={autoFocus}
                type={type}
                onChange={this.handleChange}
                error={errors[name] && true}
                inputProps={inputProps}
                // helperText={errors[name]}
            />
        );
    };

    renderSimpleInput = (label, type = "text", name, autoFocus = false, maxlength = 0) => {
        const { data } = this.state;
        const { errors } = this.state;
        const inputProps = {};
        if (maxlength > 0) {
            inputProps["maxLength"] = maxlength;
        }

        return (
            <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                id={name}
                label={label}
                name={name}
                value={data[name]}
                autoComplete={name}
                autoFocus={autoFocus}
                type={type}
                onChange={this.handleChange}
                error={errors[name] && true}
                inputProps={inputProps}
            />
        );
    };

    updateState = (key, val) => {
        const checkboxes = { ...this.state.checkboxes };
        checkboxes[key] = val;
        this.setState({ checkboxes });
    };

    render() {
        const { checkboxes, errorMessage, openLoading } = this.state;

        const { classes } = this.props;
        // const therapist = useSelector(state => state.data.therapist);
        // if (therapist || localStorage.getItem("token")) return <Redirect to={"/"} />;
        if (localStorage.getItem("token")) return <Redirect to={"/"} />;
        return (
            <Grid container component="main" className={classes.root}>
                <CssBaseline />
                <Grid item xs={false} sm={4} md={7} className={classes.image} />
                <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                    <form onSubmit={this.handleSubmit} className={classes.form}>
                        <div style={{ height: 0, overflow: "hidden" }}>
                            <input type="email" name="emaile" />
                            <input type="password" />
                        </div>

                        <div className={classes.paper}>
                            <Avatar className={classes.avatar}>
                                <ApartmentOutlinedIcon />
                            </Avatar>
                            <Typography component="h1" variant="h5">
                                Opret klinik / firma
                            </Typography>

                            {this.renderInput("Klinikens navn / Firmanavn", "text", "companyName", true, 100)}

                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    {this.renderSimpleInput("CVR", "text", "CVR", false, 8)}
                                </Grid>
                                <Grid item xs={4}>
                                    {this.renderInput("Postnummer", "text", "post", false, 100)}
                                </Grid>
                                <Grid item xs={4}>
                                    {this.renderInput("By", "text", "town", false, 100)}
                                </Grid>
                            </Grid>
                            {this.renderInput("Adresse", "text", "address", false, 100)}
                            {this.renderInput("Firma e-mail", "text", "companyEmail", false, 100)}
                            {this.renderInput("Firma telefon", "text", "companyPhone", false, 20)}

                            <div style={{ height: "20px" }} />
                        </div>
                        <div className={classes.paper}>
                            <Avatar className={classes.avatar}>
                                <PermIdentityOutlinedIcon />
                            </Avatar>
                            <Typography component="h1" variant="h5">
                                Opret den første bruger
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    {this.renderInput("Fornavn", "text", "nameFirst", false, 100)}
                                </Grid>
                                <Grid item xs={6}>
                                    {this.renderInput("Efternavn", "text", "nameLast", false, 100)}
                                </Grid>
                            </Grid>
                            {this.renderInput("Telefon", "text", "phone", false, 20)}
                            {this.renderInput("Email", "text", "email", false, 100)}
                            {this.renderInput("Adgangskode", "password", "password", false, 100)}
                            {this.renderInput("Bekræft kodeord", "password", "confirmPassword", false, 100)}

                            <div style={{ height: "20px" }} />
                            <Grid style={{ width: "100%" }} item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={checkboxes.checked}
                                            onChange={() => this.updateState("checked", !checkboxes.checked)}
                                            color="primary"
                                        />
                                    }
                                    label={
                                        <span>
                                            Jeg har læst og accepteret HandsOn Bookings &nbsp;
                                            <ALink
                                                href="#"
                                                onClick={() => this.updateState("terms", !checkboxes.terms)}>
                                                handelsbetingelser
                                            </ALink>{" "}
                                            {""}
                                            og {""}
                                            <ALink href="/pdf/Datapolitik HandsOnBooking.pdf" target="_blank">
                                                Datapolitik
                                            </ALink>
                                        </span>
                                    }
                                />
                            </Grid>
                            <Grid style={{ width: "100%" }} item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            value="true"
                                            checked={checkboxes.sendEmails}
                                            onChange={() => this.updateState("sendEmails", !checkboxes.sendEmails)}
                                            color="primary"
                                        />
                                    }
                                    label={
                                        <span>
                                            Jeg tillader at HandsOn Booking sender mig nyhedsbreve samt en indledende
                                            brugervejledning
                                        </span>
                                    }
                                />
                            </Grid>

                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}>
                                Registrer
                            </Button>
                            <Grid container>
                                <Grid item xs></Grid>
                                <Link to={{ pathname: "/" }} variant="body2">
                                    {" "}
                                    {"Har du allerede en konto? Log Ind"}
                                </Link>
                            </Grid>
                            <Box mt={5}>
                                <Copyright />
                            </Box>
                        </div>
                    </form>
                </Grid>
                <Terms open={checkboxes.terms} handleClose={() => this.updateState("terms", false)} />
                <Alert
                    open={errorMessage !== ""}
                    handleClose={() => this.setState({ errorMessage: "" })}
                    message={errorMessage}
                    title="Fejl"
                />
                <Loading open={openLoading} />
            </Grid>
        );
    }
}

export default useStyles(Register);
